import React, { Component } from 'react';
import { format_date_technical, format_price } from '../../functions/functions_formatting.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';
import ForminputText from '../forminput/forminput_text.js';
import ForminputDate from '../forminput/forminput_date.js';


export default class Triplist extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                trip_id_min: "",
                trip_id_max: "",
                title: "",
                country: "",
                city: "",
                rating_min: "",
                rating_max: "",
                price_min: "",
                price_max: "",
                activities_count_min: "",
                activities_count_max: "",
                views_count_min: "",
                views_count_max: "",
                owner: "",
                created_from: "",
                created_to: "",
                updated_from: "",
                updated_to: "",
                collections: "",
                unlocks_purchases_min: "",
                unlocks_purchases_max: "",
                settings_active: "",
                settings_private: "",
                settings_findable: ""
            },
            filter_reset_counter: 0,
            show_filters: false
        };
        this.setFilter = this.setFilter.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.toggleBinaryFilter = this.toggleBinaryFilter.bind(this);
        this.setDropdownFilter = this.setDropdownFilter.bind(this);
        this.toggleFilters = this.toggleFilters.bind(this);
    }


    setFilter(name, value) {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
                [name]: value
            }
        }));
    }


    clearFilters() {
        this.setState({
            filters: {
                trip_id_min: "",
                trip_id_max: "",
                title: "",
                country: "",
                city: "",
                rating_min: "",
                rating_max: "",
                price_min: "",
                price_max: "",
                activities_count_min: "",
                activities_count_max: "",
                views_count_min: "",
                views_count_max: "",
                owner: "",
                created_from: "",
                created_to: "",
                updated_from: "",
                updated_to: "",
                collections: "",
                unlocks_purchases_min: "",
                unlocks_purchases_max: "",
                settings_active: "",
                settings_private: "",
                settings_findable: ""
            },
            filter_reset_counter: this.state.filter_reset_counter + 1
        });
    }


    setDropdownFilter(name, value) {
        if (value === "Any") {
            this.setFilter(name, "");
            return;
        }
        this.setFilter(name, value);
    }


    toggleBinaryFilter(name, value) {
        this.setState((prevState) => {
            var currentValue = prevState.filters[name];
            var nextValue = currentValue === value ? "" : value;
            return {
                filters: {
                    ...prevState.filters,
                    [name]: nextValue
                }
            };
        });
    }


    toggleFilters() {
        this.setState((prevState) => ({
            show_filters: !prevState.show_filters
        }));
    }


    getUnlocksPurchasesCount(tripElement) {
        var candidates = [
            tripElement.unlocks_purchases_count,
            tripElement.unlocks_count,
            tripElement.purchases_count,
            tripElement.orders_count,
            tripElement.unlocks,
            tripElement.purchases,
            tripElement.orders
        ];
        for (var i = 0; i < candidates.length; i++) {
            var value = candidates[i];
            if (Array.isArray(value)) {
                return value.length;
            }
            if (value || value === 0) {
                return parseInt(value) || 0;
            }
        }
        return 0;
    }


    getTripPrice(tripElement) {
        var rawPrice = tripElement && tripElement.settings ? tripElement.settings.price : 0;
        var numericPrice = Number(rawPrice);
        if (isNaN(numericPrice) || numericPrice < 0) {
            return 0;
        }
        return numericPrice;
    }


    render() {
        var enableFilters = this.props.enableFilters === true;
        var tripdata = this.props.tripdata || [];
        var filters = this.state.filters;
        var filterResetCounter = this.state.filter_reset_counter;
        var showFilters = this.state.show_filters;

        var includesText = (fieldValue, filterValue) => {
            var value = String(fieldValue || "").toLowerCase();
            var query = String(filterValue || "").toLowerCase();
            return value.includes(query);
        };
        var matchDropdownValue = (selectedValue, possibleValues = []) => {
            if (!selectedValue) {
                return true;
            }
            return possibleValues.some((value) => String(value || "") === String(selectedValue));
        };
        var inNumericRange = (value, minValue, maxValue) => {
            var numericValue = Number(value);
            if (isNaN(numericValue)) {
                return false;
            }
            if (minValue !== "" && numericValue < Number(minValue)) {
                return false;
            }
            if (maxValue !== "" && numericValue > Number(maxValue)) {
                return false;
            }
            return true;
        };
        var matchesDateRange = (value, fromValue, toValue) => {
            if (!fromValue && !toValue) {
                return true;
            }
            if (!value) {
                return false;
            }
            var valueDate = new Date(value);
            if (isNaN(valueDate.getTime())) {
                return false;
            }
            if (fromValue) {
                var fromDate = new Date(fromValue);
                fromDate.setHours(0, 0, 0, 0);
                if (valueDate < fromDate) {
                    return false;
                }
            }
            if (toValue) {
                var toDate = new Date(toValue);
                toDate.setHours(23, 59, 59, 999);
                if (valueDate > toDate) {
                    return false;
                }
            }
            return true;
        };
        var countryOptions = [...new Set(tripdata.flatMap((element) => (element.countries || []).map((countryElement) => String(countryElement || "").trim())).filter((element) => element.length >= 1))]
            .sort((a, b) => a.localeCompare(b));
        var cityOptions = [...new Set(tripdata.flatMap((element) => (element.cities || []).map((cityElement) => String(cityElement || "").trim())).filter((element) => element.length >= 1))]
            .sort((a, b) => a.localeCompare(b));
        var ownerOptions = [...new Set(tripdata.map((element) => ({
            id: String(element.owner_id || "").trim(),
            username: String((element.owner && element.owner.username) || "").trim()
        })).filter((element) => element.id.length >= 1).map((element) => JSON.stringify(element)))]
            .map((element) => JSON.parse(element))
            .sort((a, b) => (a.username || a.id).localeCompare(b.username || b.id));
        var ownerOptionLabels = ownerOptions.map((element) =>
            element.username ? element.username + " (#" + element.id + ")" : "#" + element.id
        );
        var collectionOptions = [...new Set(tripdata.flatMap((element) => (element.collection || []).map((collectionElement) => String(collectionElement || "").trim())).filter((element) => element.length >= 1))]
            .sort((a, b) => a.localeCompare(b));

        var binaryButtonStyle = (selected) => ({
            backgroundColor: selected ? "#2E7D32" : "#9E9E9E",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "6px",
            padding: "8px 10px",
            cursor: "pointer",
            fontWeight: "bold"
        });

        var matchBooleanFilter = (booleanValue, filterValue) => {
            if (!filterValue) {
                return true;
            }
            return String(!!booleanValue) === String(filterValue);
        };

        var filteredData = tripdata.filter((tripElement) => {
            var updatedValue = tripElement.updated && tripElement.updated.length >= 1
                ? tripElement.updated[tripElement.updated.length - 1]
                : null;
            var unlocksPurchasesCount = this.getUnlocksPurchasesCount(tripElement);
            var tripPrice = this.getTripPrice(tripElement);
            var isActive = tripElement.settings && tripElement.settings.active;
            var isPrivate = tripElement.settings ? !tripElement.settings.public : false;
            var isFindable = tripElement.settings && tripElement.settings.findable;
            var tripCountries = tripElement.countries || [];
            var tripCities = tripElement.cities || [];
            var tripCollections = tripElement.collection || [];
            var ownerId = String(tripElement.owner_id || "");
            var ownerLabel = tripElement.owner && tripElement.owner.username
                ? tripElement.owner.username + " (#" + ownerId + ")"
                : "#" + ownerId;

            if (!inNumericRange(tripElement.trip_id, filters.trip_id_min, filters.trip_id_max)) return false;
            if (!includesText(tripElement.title, filters.title)) return false;
            if (!matchDropdownValue(filters.country, tripCountries)) return false;
            if (!matchDropdownValue(filters.city, tripCities)) return false;
            if (!inNumericRange((tripElement.rate || tripElement.rate === 0) ? tripElement.rate : 0, filters.rating_min, filters.rating_max)) return false;
            if (!inNumericRange(tripPrice, filters.price_min, filters.price_max)) return false;
            if (!inNumericRange((tripElement.activities_count || tripElement.activities_count === 0) ? tripElement.activities_count : 0, filters.activities_count_min, filters.activities_count_max)) return false;
            if (!inNumericRange((tripElement.views || tripElement.views === 0) ? tripElement.views : 0, filters.views_count_min, filters.views_count_max)) return false;
            if (!matchDropdownValue(filters.owner, [ownerLabel])) return false;
            if (!matchesDateRange(tripElement.created, filters.created_from, filters.created_to)) return false;
            if (!matchesDateRange(updatedValue, filters.updated_from, filters.updated_to)) return false;
            if (!matchDropdownValue(filters.collections, tripCollections)) return false;
            if (!inNumericRange(unlocksPurchasesCount, filters.unlocks_purchases_min, filters.unlocks_purchases_max)) return false;
            if (!matchBooleanFilter(isActive, filters.settings_active)) return false;
            if (!matchBooleanFilter(isPrivate, filters.settings_private)) return false;
            if (!matchBooleanFilter(isFindable, filters.settings_findable)) return false;
            return true;
        });

        return (
            <div className="admindashboard__section">
                <div className="admindashboard__section__title text-title">
                    Trips
                </div>
                <div className="admindashboard__section__content">
                    {enableFilters &&
                        <div className="admindashboard__section__content__element">
                            <div onClick={this.toggleFilters} className={("button " + (showFilters ? "button-primary-light" : "button-primary"))}>
                                {showFilters ? "Hide filters" : "Show filters"}
                            </div>
                            <div>
                                {filteredData.length + " / " + tripdata.length + " trips"}
                            </div>
                        </div>
                    }

                    {enableFilters && showFilters &&
                        <div className="admindashboard__section__content__element">
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "8px" }}>
                                <ForminputText
                                    key={"trip_id_min-" + filterResetCounter}
                                    name={"trip_id_min"}
                                    label={""}
                                    default_value={filters.trip_id_min || ""}
                                    placeholder={"Trip ID from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"trip_id_max-" + filterResetCounter}
                                    name={"trip_id_max"}
                                    label={""}
                                    default_value={filters.trip_id_max || ""}
                                    placeholder={"Trip ID to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"title-" + filterResetCounter}
                                    name={"title"}
                                    label={""}
                                    default_value={filters.title || ""}
                                    placeholder={"Title"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDropdown
                                    key={"country-" + filterResetCounter + "-" + filters.country}
                                    name={"country"}
                                    label={""}
                                    list={["Any", ...countryOptions]}
                                    default_value={filters.country || ""}
                                    placeholder={"Country"}
                                    setFormValue={this.setDropdownFilter}
                                    required={false}
                                />
                                <ForminputDropdown
                                    key={"city-" + filterResetCounter + "-" + filters.city}
                                    name={"city"}
                                    label={""}
                                    list={["Any", ...cityOptions]}
                                    default_value={filters.city || ""}
                                    placeholder={"City"}
                                    setFormValue={this.setDropdownFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"rating_min-" + filterResetCounter}
                                    name={"rating_min"}
                                    label={""}
                                    default_value={filters.rating_min || ""}
                                    placeholder={"Rating from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"rating_max-" + filterResetCounter}
                                    name={"rating_max"}
                                    label={""}
                                    default_value={filters.rating_max || ""}
                                    placeholder={"Rating to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"price_min-" + filterResetCounter}
                                    name={"price_min"}
                                    label={""}
                                    default_value={filters.price_min || ""}
                                    placeholder={"Price from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"price_max-" + filterResetCounter}
                                    name={"price_max"}
                                    label={""}
                                    default_value={filters.price_max || ""}
                                    placeholder={"Price to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"activities_count_min-" + filterResetCounter}
                                    name={"activities_count_min"}
                                    label={""}
                                    default_value={filters.activities_count_min || ""}
                                    placeholder={"Activities from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"activities_count_max-" + filterResetCounter}
                                    name={"activities_count_max"}
                                    label={""}
                                    default_value={filters.activities_count_max || ""}
                                    placeholder={"Activities to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"views_count_min-" + filterResetCounter}
                                    name={"views_count_min"}
                                    label={""}
                                    default_value={filters.views_count_min || ""}
                                    placeholder={"Views from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"views_count_max-" + filterResetCounter}
                                    name={"views_count_max"}
                                    label={""}
                                    default_value={filters.views_count_max || ""}
                                    placeholder={"Views to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDropdown
                                    key={"owner-" + filterResetCounter + "-" + filters.owner}
                                    name={"owner"}
                                    label={""}
                                    list={["Any", ...ownerOptionLabels]}
                                    default_value={filters.owner || ""}
                                    placeholder={"Owner"}
                                    setFormValue={this.setDropdownFilter}
                                    required={false}
                                />
                                <ForminputDate
                                    key={"created_from-" + filterResetCounter}
                                    name={"created_from"}
                                    label={"Created from"}
                                    default_value={filters.created_from || ""}
                                    placeholder={"Created from"}
                                    note={""}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDate
                                    key={"created_to-" + filterResetCounter}
                                    name={"created_to"}
                                    label={"Created to"}
                                    default_value={filters.created_to || ""}
                                    placeholder={"Created to"}
                                    note={""}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDate
                                    key={"updated_from-" + filterResetCounter}
                                    name={"updated_from"}
                                    label={"Updated from"}
                                    default_value={filters.updated_from || ""}
                                    placeholder={"Updated from"}
                                    note={""}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDate
                                    key={"updated_to-" + filterResetCounter}
                                    name={"updated_to"}
                                    label={"Updated to"}
                                    default_value={filters.updated_to || ""}
                                    placeholder={"Updated to"}
                                    note={""}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputDropdown
                                    key={"collections-" + filterResetCounter + "-" + filters.collections}
                                    name={"collections"}
                                    label={""}
                                    list={["Any", ...collectionOptions]}
                                    default_value={filters.collections || ""}
                                    placeholder={"Collection"}
                                    setFormValue={this.setDropdownFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"unlocks_purchases_min-" + filterResetCounter}
                                    name={"unlocks_purchases_min"}
                                    label={""}
                                    default_value={filters.unlocks_purchases_min || ""}
                                    placeholder={"Unlocks/purchases from"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <ForminputText
                                    key={"unlocks_purchases_max-" + filterResetCounter}
                                    name={"unlocks_purchases_max"}
                                    label={""}
                                    default_value={filters.unlocks_purchases_max || ""}
                                    placeholder={"Unlocks/purchases to"}
                                    setFormValue={this.setFilter}
                                    required={false}
                                />
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                    <span>Active</span>
                                    <div style={{ display: "flex", gap: "6px" }}>
                                        <button type="button" style={binaryButtonStyle(filters.settings_active === "true")} onClick={() => this.toggleBinaryFilter("settings_active", "true")}>
                                            Yes
                                        </button>
                                        <button type="button" style={binaryButtonStyle(filters.settings_active === "false")} onClick={() => this.toggleBinaryFilter("settings_active", "false")}>
                                            No
                                        </button>
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                    <span>Private</span>
                                    <div style={{ display: "flex", gap: "6px" }}>
                                        <button type="button" style={binaryButtonStyle(filters.settings_private === "true")} onClick={() => this.toggleBinaryFilter("settings_private", "true")}>
                                            Yes
                                        </button>
                                        <button type="button" style={binaryButtonStyle(filters.settings_private === "false")} onClick={() => this.toggleBinaryFilter("settings_private", "false")}>
                                            No
                                        </button>
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                    <span>Findable</span>
                                    <div style={{ display: "flex", gap: "6px" }}>
                                        <button type="button" style={binaryButtonStyle(filters.settings_findable === "true")} onClick={() => this.toggleBinaryFilter("settings_findable", "true")}>
                                            Yes
                                        </button>
                                        <button type="button" style={binaryButtonStyle(filters.settings_findable === "false")} onClick={() => this.toggleBinaryFilter("settings_findable", "false")}>
                                            No
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "12px" }}>
                                <button type="button" onClick={this.clearFilters} className="button button-light">
                                    Clear filters
                                </button>
                            </div>
                        </div>
                    }

                    {(tripdata && tripdata.length >= 1) &&
                        <>
                            <div style={{ overflowX: "auto" }}>
                                <div className="admindashboard__section__content__table" style={{ gridTemplateColumns: "0.8fr 1.3fr 1fr 1fr 0.7fr 0.8fr 0.8fr 0.8fr 1.2fr 1fr 1fr 1fr 1.2fr 0.9fr", minWidth: "1720px" }}>

                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Trip ID
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Title
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Country
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        City
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Rating
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Price
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Views
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Unlocks
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Settings
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Owner
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Created
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Last updated
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Collections
                                    </div>
                                    <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                        Unlocks/purchases
                                    </div>

                                    {filteredData.map((tripElement, i) => {
                                        var tripId = tripElement.trip_id;
                                        return (
                                            <React.Fragment key={i}>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.trip_id ? tripElement.trip_id : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.title ? tripElement.title : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.countries && tripElement.countries.length >= 1 ? tripElement.countries.join(", ") : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.cities && tripElement.cities.length >= 1 ? tripElement.cities.join(", ") : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {(tripElement.rate || tripElement.rate === 0) ? tripElement.rate : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {format_price(this.getTripPrice(tripElement))}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {(tripElement.views || tripElement.views === 0) ? tripElement.views : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {(tripElement.unlocks || tripElement.unlocks === 0) ? tripElement.unlocks : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.settings && tripElement.settings.active ? "Active" : "Inactive"}
                                                    {", "}
                                                    {tripElement.settings && tripElement.settings.public ? "Public" : "Private"}
                                                    {", "}
                                                    {tripElement.settings && tripElement.settings.findable ? "Findable" : "Link-only"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.owner && tripElement.owner.username ? tripElement.owner.username : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.created ? format_date_technical(tripElement.created) : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.updated && tripElement.updated.length >= 1 ? format_date_technical(tripElement.updated[tripElement.updated.length - 1]) : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {tripElement.collection && tripElement.collection.length >= 1 ? tripElement.collection.join(", ") : "-"}
                                                </div>
                                                <div onClick={() => this.props.setTrip(tripId)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                                    {this.getUnlocksPurchasesCount(tripElement)}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>

                            {filteredData.length < 1 &&
                                <div style={{ marginTop: "12px" }}>
                                    No trips match the current filters.
                                </div>
                            }
                        </>
                    }
                </div>
            </div>
        )
    }
}
